import styled from 'styled-components';
import { colorPalette, getSpacing } from 'stylesheet';

export const LayoutContainer = styled.div`
  display: flex;
  height: 100%;
  overflow: hidden;
`;

export const BodyContainer = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  padding: ${getSpacing(3)};
  background-color: ${colorPalette.backgroundMain};
  flex: 1;
  @media (max-width: 940px) and (max-height: 440px) {
    padding-top: 0;
    overflow-y: auto;
  }
  @media (max-height: 950px) {
    overflow-y: auto;
  }
`;
